import { render, staticRenderFns } from "./MessageActions.vue?vue&type=template&id=3fefb996&scoped=true&"
import script from "./MessageActions.vue?vue&type=script&lang=js&"
export * from "./MessageActions.vue?vue&type=script&lang=js&"
import style0 from "./MessageActions.vue?vue&type=style&index=0&id=3fefb996&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fefb996",
  null
  
)

export default component.exports